import React, { useEffect } from 'react';
import UbbeCardHeader from '../global-components/cardHeader';

const MonerisContainer: React.FC = () => {
  let apiKeyId = process.env.REACT_APP_UBBE_MONERIS_API_ID;
  const inputStyle =
    'width:100%;display:block;margin-bottom:1rem;padding-top:0.375rem;padding-right:0.75rem;padding-bottom:0.375rem;padding-left:0.75rem;font-size:1rem;line-height:1.5;background-color:rgb(255,255,255);border-top-color:rgb(37,33,95);border-top-style:solid;border-top-width:1px;border-right-color:rgb(37,33,95);border-right-style:solid;border-right-width:2px;border-bottom-color:rgb(37,33,95);border-bottom-style:solid;border-bottom-width:1px;border-left-color:rgb(37,33,95);border-left-style:solid;border-left-width:1px;border-radius:.25rem;';

  const newIframeSrc = `${process.env.REACT_APP_UBBE_MONERIS_HPP_TOKEN_URL}?id=${apiKeyId}&pmmsg=true&css_body=background:transparent;&css_textbox=border-width:2px;&display_labels=1&css_textbox_pan=${inputStyle}&pan_label=Credit Card&css_label_pan=font-weight:400;font-family:Verdana;&enable_exp=1&exp_label=Expiry Date (MMYY)&css_label_exp=font-weight:400;font-family:Verdana&css_textbox_exp=${inputStyle};&enable_cvd=1&cvd_label=CVV&css_label_cvd=font-weight:400;font-family:Verdana;&css_textbox_cvd=${inputStyle}`;

  return (
    <div className='ubbe-card mt-4'>
      <UbbeCardHeader headerText={'Payment Details'} />
      <div className='card-body p-4'>
        <iframe
          id={'monerisFrame'}
          src={newIframeSrc}
          width='100%'
          height='225'
        ></iframe>
        <input type='hidden' id='moneris_token' />

        <div id={'monerisResponse'}></div>
      </div>
    </div>
  );
};

export default MonerisContainer;
